import axios from "axios";
import { baseApiUrl } from "../../../../env";
import axiosInstance from "../../../../Axios/axios";



// http://192.168.3.17:91/api/v1/OrderDesignHistory/GetAllOrderDesignHistoryWithTotal








const GetAllOrderDesignHistoryWithTotal=async({queryKey})=>{
    let body=queryKey[1];
    return await axiosInstance.post('OrderDesignHistory/GetAllOrderDesignHistoryWithTotal',body)
}




const GetOrderDesigner = async ({queryKey}) => {
  const GetOrdersAssignToDesigner =`DesigningDepartment/GetOrdersAssignToDesigner`;
//   const addOrders_URL = GetOrdersAssignToDesigner;
  const body=queryKey[1]
   return  await axiosInstance.post(GetOrdersAssignToDesigner, body);
  
};

// http://192.168.3.17:91/api/v1/Order/SimpleGetAllOrders

const SimpleGetAllOrders = async ({queryKey}) => {
  const SimpleGetAllOrders_url =`Order/SimpleGetAllOrders`;
  const body=queryKey[1]
  return await axiosInstance.post(SimpleGetAllOrders_url, body);
 
};

// http://192.168.3.17:91/api/v1/OrderDesignHistory/AddOrderDesignHistory



const AddOrderDesignHistory=async(body)=>{
    return await axiosInstance.post('OrderDesignHistory/AddOrderDesignHistory',body)
}

// http://192.168.3.17:91/api/v1/OrderDesignHistory/UpdateOrderDesignHistory
const UpdateOrderDesignHistory=async(body)=>{
    return await axiosInstance.post('OrderDesignHistory/UpdateOrderDesignHistory',body)
}
// http://192.168.3.17:91/api/v1/

const DeleteOrderDesignHistory=async(historyId)=>{
    return await axiosInstance.delete(`OrderDesignHistory/DeleteOrderDesignHistory?orderDesignHistoryId=${historyId}`)
}



// http://192.168.3.17:91/api/v1/OrderDesignHistory/GetDesignerPerformance

const GetDesignerPerformance=async({queryKey})=>{
    let body=queryKey[1];
    return await axiosInstance.post(`OrderDesignHistory/GetDesignerPerformance`,body)
}


export{
GetAllOrderDesignHistoryWithTotal,
SimpleGetAllOrders,
AddOrderDesignHistory,
UpdateOrderDesignHistory,
DeleteOrderDesignHistory,
GetDesignerPerformance
}